module.exports = "<p>{{'quoteandbind.pa.directives.templates.pa-quick-indicative.Sorry, based on the data entered this quote cannot be completed online.' | translate}}</p>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/quickquote/pa/tiles/quote/directives/templates/pa-quick-quote-quote-error-state.html
 ** module id = 848
 ** module chunks = 0
 **/